import { FunctionComponent } from "react";

import { format } from "date-fns";

import { DeepResearchStatusIcon } from "@/components/DeepResearchStatusIcon/DeepResearchStatusIcon";

import { TrackerOrganization } from "../../schema/trackerOrganizations";

import { useDeepResearchSocketContext } from "../../providers/DeepResearchSocketContext";

interface DeepResearchStatusCellProps {
	row: TrackerOrganization;
	onResearchClick?: (row: TrackerOrganization) => void;
}

export const DeepResearchStatusCell: FunctionComponent<DeepResearchStatusCellProps> = ({
	row,
	onResearchClick,
}) => {
	const { isPending } = useDeepResearchSocketContext();

	const trackerPersonWithResearch = row.trackerPersons?.find(
		(tp) =>
			tp.prospect?.deepResearchResponse?.response &&
			Object.keys(tp.prospect.deepResearchResponse.response).length > 0
	);
	const isDone = !!trackerPersonWithResearch;
	const isRunning = !!row.trackerPersons?.some(
		(tp) => tp.prospect?.id && isPending(tp.prospect.id)
	);

	const deepResearch = trackerPersonWithResearch?.prospect?.deepResearchResponse;
	const createdAt = deepResearch?.createdAt
		? format(new Date(deepResearch.createdAt), "yyyy-MM-dd HH:mm")
		: "";

	let tooltipText = "Deep Research / not started";

	if (isRunning) {
		tooltipText = "Deep Research / running…";
	} else if (isDone) {
		tooltipText = `Deep Research / done${createdAt ? ` | ${createdAt}` : ""}`;
	}

	return (
		<DeepResearchStatusIcon
			fitAssessment={deepResearch?.fitAssessment}
			isDone={isDone}
			isRunning={isRunning}
			tooltipText={tooltipText}
			onClick={() => onResearchClick?.(row)}
		/>
	);
};
